<template>
  <div
    class="w-full h-full shrink-0 snap-center snap-always"
  >
    <AppVideoPlayer
      :video="video"
      no-click
      @click="emit('click')"
    />
  </div>
</template>

<script setup lang="ts">
import type { SwipeVideo } from './types'

defineProps<{
  video: SwipeVideo
}>()

const emit = defineEmits<{
  click: []
}>()
</script>
